import React, { useState, useRef } from "react";
import domtoimage from "dom-to-image";
import style from "./PlacaLuxury.module.css";
import logo from '../../../Assets/sinFondo.png';
import ubicacion from '../../../Assets/marcador-de-posicion (2).png';
import nuevoLogo from '../../../Assets/nuevoLogo.png'

const PlacaLuxury = () => {
  const [images, setImages] = useState({
    mainImage: null,
    mainImage2: null,
    secondaryImage1: null,
    secondaryImage2: null,
    secondaryImage3: null, // Nueva imagen secundaria
  });

  const [features, setFeatures] = useState(
    "5 Habitaciones, 6 Baños, Cocina Completa, Lavandería, Quincho, Pileta, Cochera para 5 Autos"
  );

  const [title, setTitle] = useState("CASA A LA VENTA");
  const [price, setPrice] = useState("U$D 230.000");
  const [location, setLocation] = useState("General Paz, Godoy Cruz");

  const placaRef = useRef(null);

  const handleImageChange = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImages((prev) => ({ ...prev, [imageType]: event.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

 const downloadPlaca = () => {
    const element = placaRef.current;
  
    // Guardar los estilos originales
    const originalStyle = element.getAttribute("style");
  
    // Aplicar estilos temporales para forzar un tamaño fijo
    element.setAttribute(
      "style",
      `
        width: 1080px;
        height: 1080px;
        transform: none;
        transform-origin: top left;
        position: relative;
      `
    );
  
    // Generar la imagen
    domtoimage
      .toPng(element)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "placa_publicitaria.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error("Error al generar la imagen:", error);
      })
      .finally(() => {
        // Restaurar los estilos originales
        if (originalStyle) {
          element.setAttribute("style", originalStyle);
        } else {
          element.removeAttribute("style");
        }
      });
  };


  return (
    <div className={style.container}>
      <div className={style.editControls}>
        {/* Controles de edición */}
        <label>
          Título:
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Precio:
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Ubicación:
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Características:
          <input
            type="text"
            value={features}
            onChange={(e) => setFeatures(e.target.value)}
            className={style.input}
            placeholder="Ej: 5 Habitaciones, 6 Baños, Cocina Completa"
          />
        </label>
      </div>

      <div ref={placaRef} className={style.placa}>
        <div className={style.price}>{price}</div>
        <div className={style.secondaryImages}>
          {/* Primera imagen secundaria */}
          <div
            className={style.secondaryImage}
            onClick={() => document.getElementById('fileInput1').click()} // Simula clic en input 1
          >
            {images.secondaryImage1 ? (
              <img src={images.secondaryImage1} alt="Secundaria 1" crossOrigin="anonymous" className={style.imgsecondary} />
            ) : (
              <p>Cargar Imagen 1</p> // Texto de indicación
            )}
            <input
              type="file"
              id="fileInput1" // Asociado al div mediante ID
              accept="image/*"
              onChange={(e) => handleImageChange(e, "secondaryImage1")}
              hidden
            />
          </div>

          {/* Segunda imagen secundaria */}
          <div
            className={style.secondaryImage2}
            onClick={() => document.getElementById('fileInput2').click()} // Simula clic en input 2
          >
            {images.secondaryImage2 ? (
              <img src={images.secondaryImage2} alt="Secundaria 2" crossOrigin="anonymous" className={style.imgsecondary} />
            ) : (
              <p>Cargar Imagen 2</p> // Texto de indicación
            )}
            <input
              type="file"
              id="fileInput2" // Asociado al div mediante ID
              accept="image/*"
              onChange={(e) => handleImageChange(e, "secondaryImage2")}
              hidden
            />
          </div>

          {/* Nueva tercera imagen secundaria */}
          <div
            className={style.secondaryImage3}
            onClick={() => document.getElementById('fileInput3').click()} // Simula clic en input
          >
            {images.secondaryImage3 ? (
              <img src={images.secondaryImage3} alt="Secundaria 3" crossOrigin="anonymous" className={style.imgsecondary} />
            ) : (
              <p>Cargar Imagen 3</p> // Texto de indicación
            )}
            <input
              type="file"
              id="fileInput3" // Asociado al div mediante ID
              accept="image/*"
              onChange={(e) => handleImageChange(e, "secondaryImage3")}
              hidden
            />
          </div>
        </div>
        <div
          className={style.mainImage}
          onClick={() => document.getElementById('fileInputMain1').click()} // Simula clic en input principal
        >
          {images.mainImage ? (
            <img src={images.mainImage} alt="Principal" />
          ) : (
            <p>Cargar Imagen Principal</p> // Texto de indicación
          )}
          <input
            type="file"
            id="fileInputMain1" // Asociado al div mediante ID
            accept="image/*"
            onChange={(e) => handleImageChange(e, "mainImage")}
            hidden
          />
        </div>
        <div className={style.secondPlaca}>
          <div className={style.content}></div>
          <h1 className={style.title}>{title}</h1>
          {location && (
            <div className={`${style.containerUbicacion} left`}>
              <img src={ubicacion} alt="" />
              <p className={style.locationTitle}>{location}</p>
            </div>
          )}
          <div className={style.logo}>
            <img src={nuevoLogo} alt="Logo" />
          </div>
          <div className={style.martilleraContainer}>
            <p className={style.martillera}>JULIETA GARCIA CCPIM 2009</p>
          </div>
          <div className={style.featuresContainer}>
            {features.trim()
              ? features
                  .split(",")
                  .map((feature) => feature.trim()) // Elimina espacios innecesarios
                  .filter((feature) => feature.length > 0) // Evita elementos vacíos
                  .map((feature, index, array) => (
                    <p key={index} className={style.featureItem}>
                      {feature} {index !== array.length - 1 && " | "}
                    </p>
                  ))
              : <p className={style.featureItem}>Sin especificar</p>}
          </div>
        </div>
      </div>

      <button onClick={downloadPlaca} className={style.downloadButton}>
        Descargar Placa
      </button>
    </div>
  );
};

export default PlacaLuxury;

